export const FETCH_LEARNING_CENTERS = 'FETCH_LEARNING_CENTERS';
